function About(){
    return(
        <>
        <div style={{height:'100vh', padding:'80px 0', textAlign:'center', color:'white'}}>
        <h1>About</h1>
        </div>
        </>
    )
}
export default About;